import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { Box } from '@fiverr-private/theme';
import { DEFAULT, EQUAL_PADDING } from './constants';
import { SectionProps } from './types';

const Section = forwardRef<HTMLElement, SectionProps>(
  ({ children, fullWidth, equalPadding, className: customClassName, ...restProps }: SectionProps, ref) => {
    const styling = () => {
      if (fullWidth) {
        return {};
      }
      if (equalPadding) {
        return EQUAL_PADDING;
      }
      return DEFAULT;
    };

    const { className, ...stylingProps } = styling();

    return (
      <Box
        ref={ref}
        width="100%"
        boxSizing="borderBox"
        margin="autoX"
        {...stylingProps}
        className={classNames(className, customClassName)}
        {...restProps}
      >
        {children}
      </Box>
    );
  }
);

Section.displayName = 'Section';

export default Section;
